<template>
    <div class="jd-page--orderDetail">
        <div v-if="getOrderDetail">
            <div class="jd-order-detailStatus--text" v-if="getOrderDetail.status === CONST.ORDER_STATUS_CANCEL">
                <order-status-text :status="getOrderDetail.status" :payst="getOrderDetail.payst" :dotimest="getOrderDetail.dotimest" />
            </div>
            <k-hr />
            <appraiser-result v-if="showResult" :info="resultInfo" :appraiser="getOrderDetail.appraiser" />

            <appraiser-item v-if="!showResult && getOrderDetail.status > CONST.ORDER_STATUS_CREATE" :info="appraiserInfo">
                <template slot="status" v-if="getOrderDetail.status === CONST.ORDER_STATUS_WAIT">
                    <span class="cl-primary" v-if="showLeftTime && dotimeps>0">鉴定倒计时 {{dotimeps|formatTime}}</span>
                    <span class="cl-primary" v-else>鉴定过期</span>
                </template>
            </appraiser-item>

            <k-cell v-if="getOrderDetail.status === CONST.ORDER_STATUS_PAUSE">
                <div class="cl-red" v-if="stopremark">
                    <k-icon name="info-o" color="coral"></k-icon>老师回复：
                    <span v-if="stopremark.pic">图片<label v-for="item in stopremark.pic" :key="item"> [{{item}}] </label>有问题，</span>
                    <span v-if="stopremark.video">视频<label v-for="item in stopremark.video" :key="item"> [{{item}}] </label>有问题，</span>
                    <span v-if="stopremark.reason">{{stopremark.reason}}</span>
                </div>
            </k-cell>

            <goods-info :des="getOrderDetail.des || ''" :files="getOrderDetail.files" :pictures="getOrderDetail.pictures" :num="true" />

            <evaluate-info v-if="getOrderDetail.status === CONST.ORDER_STATUS_EVALUATE" :star="getOrderDetail.star || 0" server="非常满意" speed="非常满意" />

            <order-info :info="orderInfo" />

            <div class="jd-fixed-btns">
                <k-button v-if="getOrderDetail.status === CONST.ORDER_STATUS_CREATE" type="primary" block :to="`/publish/appraisers?orderId=${id}&tabid=${getOrderDetail.tabid}`">下一步选择老师</k-button>
                <k-button v-if="getOrderDetail.status === CONST.ORDER_STATUS_PAUSE" type="primary" block :to="`/publish/edit?id=${id}`">重新上传</k-button>
                <k-button v-if="getOrderDetail.status === CONST.ORDER_STATUS_TOPAY" type="primary" block @click="toPay" :disabled="isPay" :loading="isPay" loading-type="spinner" loading-text="正在跳转..." >立即支付</k-button>
                <k-button v-if="getOrderDetail.status === CONST.ORDER_STATUS_FINISHED" type="primary" block @click="evaluatePopup=true">点击评价</k-button>
                <k-button v-if="getOrderDetail.status === CONST.ORDER_STATUS_CANCEL" type="primary" block :to="`/publish/edit?id=${id}&redo=1`">重新鉴定</k-button>
            </div>

        </div>
        <k-popup v-model="evaluatePopup" position="bottom" v-if="getOrderDetail">
            <k-icon name="close-o" size="26" color="gainsboro" class="" @click="evaluatePopup=false" />
            <evaluate-form v-if="getOrderDetail.status === CONST.ORDER_STATUS_FINISHED" :order-id="getOrderDetail.id" @success="evaluatePopup=false"></evaluate-form>
        </k-popup>
    </div>
</template>

<script>
    import {mapActions, mapGetters, mapMutations} from "vuex"
    import AppraiserResult from "../components/appraiser-result"
    import EvaluateForm from "../components/evaluate-form"
    import EvaluateInfo from "../components/evaluate-info"
    import GoodsInfo from "../components/goods-info"
    import OrderStatusText from "../components/order-status-text"
    import OrderInfo from "../components/order-info"
    import {time2text} from "../../utils/xp.v1"
    export default {
        name: "order-detail",
        data(){
            return {
                evaluatePopup : false,
                id : +this.$route.query.orderId || 0,
                isPay : false
            }
        },
        computed : {
            ...mapGetters("jianding", ["getOrderDetail","CONST"]),
            ...mapGetters("timer", ["leftSecs"]),
            showLeftTime(){
                let od = this.getOrderDetail;
                let {ORDER_STATUS_WAIT} = this.CONST;
                if(!od.dotimest && od.status === ORDER_STATUS_WAIT) {
                    return true
                }
                return false
            },
            showResult(){
                let od = this.getOrderDetail;
                let {ORDER_STATUS_FINISHED, ORDER_STATUS_EVALUATE} = this.CONST;
                if (od.status === ORDER_STATUS_FINISHED || od.status === ORDER_STATUS_EVALUATE) {
                    return true
                }
                return false
            },
            resultInfo(){
                let {id, aid, type, definition, periods, trend, reply, isReal} = this.getOrderDetail;
                return {id, aid, type, definition, periods, trend, reply, isReal}
            },
            orderInfo(){
                let {id, orderno, status, money, createtime, paytime, payps, payst} = this.getOrderDetail;
                return {id, orderno, status, money, createtime, paytime, payps, payst}
            },
            goodsInfo(){
                let {des, pictures, files } = this.getOrderDetail;
                return {des, pictures, files }
            },
            appraiserInfo(){
                let { appraiser } = this.getOrderDetail;
                //if(!appraiser) return ;
                let {aid, name, des, logo, tabs} = appraiser || {};
                return {aid, name, des, logo, tabs}
            },
            dotimeps(){
                let {dotimeps} = this.getOrderDetail;
                return this.leftSecs(dotimeps*1000)
            },
            stopremark(){
                let {stopremark} = this.getOrderDetail;
                return stopremark
            }
        },
        components : {
            AppraiserResult,
            EvaluateForm,
            EvaluateInfo,
            GoodsInfo,
            OrderStatusText,
            OrderInfo
        },
        methods : {
            ...mapActions("jianding", ["loadOrderDetail", "makeOrder", "loadCert"]),
            ...mapMutations("jianding", ["delOrderDetail"]),
            async toPay(){
                this.isPay = true;
                setTimeout(()=>{
                    this.$toast("请求超时，请重试");
                    this.isPay = false;
                },15000);
                await this.makeOrder({orderId:this.id})

            }
        },
        created() {
          this.loadOrderDetail({id:this.id});
        },
        beforeDestroy() {
            this.delOrderDetail()
        }

    }
</script>

<style scoped>

</style>